import { z } from 'zod';

/**
 * Altdaten-Import der Referenzen (ADR 0101): einmaliger Import des
 * Base44-„Referenzen"-Exports (JSON, ein Array von Objekten). Zwei Schritte,
 * dieselbe Eingabe — `analyze` (Trockenlauf, schreibt nichts) und `execute`
 * (schreibt idempotent über `importedRowId('Reference', legacyId)`, Muster
 * `base44-import`). Der Verweis auf ein ProERP-Projekt (`project_no`, Freitext,
 * bei den meisten Zeilen leer) wird best-effort über `matchProjects()`
 * aufgelöst — kein Treffer ist der Normalfall, keine Zeile scheitert deshalb.
 */
export const referenceImportInputSchema = z.object({
  referencesJson: z.string().min(1).max(20_000_000),
  /** Bereits importierte Referenzen mit dem aktuellen JSON-Inhalt überschreiben statt überspringen. */
  updateExisting: z.boolean().optional().default(false),
});
export type ReferenceImportInput = z.infer<typeof referenceImportInputSchema>;

const referenceImportFailureSchema = z.object({ id: z.string(), reason: z.string() });

export const referenceImportReportSchema = z.object({
  /** true = `execute` (geschrieben), false = `analyze` (Trockenlauf, nichts geschrieben). */
  applied: z.boolean(),
  read: z.number().int(),
  created: z.number().int(),
  /** Deterministische ID existiert schon und `updateExisting` war gesetzt — überschrieben. */
  updated: z.number().int(),
  /** Deterministische ID existiert schon, `updateExisting` war nicht gesetzt — Re-Run, No-op. */
  alreadyImported: z.number().int(),
  /** `project_no` konnte einem ProERP-Projekt zugeordnet werden. */
  linkedToProject: z.number().int(),
  /** `project_no` leer oder ohne Treffer — Referenz wird trotzdem angelegt, nur ohne Projekt-Bezug. */
  notLinked: z.number().int(),
  digitMatches: z.number().int(),
  normalizedMatches: z.number().int(),
  failed: z.array(referenceImportFailureSchema),
});
export type ReferenceImportReport = z.infer<typeof referenceImportReportSchema>;
